<template>
  <button
    :class="buttonClasses"
    :disabled="disabled"
    :title="title"
    @click="pageChange"
  >
    <span v-html="html" />
  </button>
</template>

<script>
export default {
  name: 'PaginationButton',

  props: {
    page: {
      type: [
        Number,
        String
      ],
      required: true
    },

    active: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    html: {
      type: String,
      required: true
    },

    title: {
      type: String,
      default: ''
    }
  },

  computed: {
    buttonClasses () {
      return {
        'pagination-button': true,
        'pagination-button--active': this.active,
        'pagination-button--disabled': this.disabled,
        'pagination-button--spacer': this.page === '...'
      }
    }
  },

  methods: {
    pageChange () {
      if (this.page === '...' || this.disabled || this.active) {
        return
      }

      this.$emit('page-change')
    }
  }
}
</script>

<style lang="scss">
.pagination-button {
  border: 1px solid #ccc;
  width: 50px;
  height: 40px;
  margin-left: -1px;
  outline: none;
  position: relative;
  color: #333;

  &:hover {
    color: var(--navBarColor);
  }

  &:focus {
    background: #f5f5f5;
    z-index: 10;
  }

  &--center {
    position: relative;
    margin-left: -1px;
  }

  &--active,
  &:active {
    z-index: 5;
    color: #000;
    font-weight: 500;
  }

  &--disabled,
  &--disabled:hover {
    cursor: default;
    color: #ccc;
  }

  &--spacer {
    @apply text-gray-800 cursor-default;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/pagination/pagination-button.vue